module.exports = __webpack_public_path__ + "img/blog-2.4ee84fa3.jpg";